var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RawVisualization',{attrs:{"server-url":_vm.serverUrl,"series-uid":_vm.seriesUid,"study-uid":_vm.studyUid,"height":"100%"}})}
var staticRenderFns = []

export { render, staticRenderFns }